type DeletedChecker = (...deleted: (string | null | undefined)[]) => boolean

/**
 * checks the deleted string to see if it _is_ deleted
 *
 * @param deleted the deleted field from geo based tables
 */
export const isDeleted: DeletedChecker = (...deleted) =>
  deleted?.some((deleted) => deleted?.toLowerCase() === 'yes')

/**
 * checks the deleted string to see if it _is not_ deleted
 * @param deleted the deleted field from geo based tables
 */
export const notDeleted: DeletedChecker = (...deleted) =>
  deleted?.some((deleted) => !deleted || deleted?.toLowerCase() === 'no')
